/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BeatLoader } from "react-spinners";
import "../assets/css/bootstrap/bootstrap.css";
import "../assets/css/bootstrap/bootstrap-grid.css";
import "../assets/css/bootstrap/bootstrap-reboot.css";
import "../assets/css/backend-plugin.min.css";
import "../assets/vendor/remixicon/fonts/remixicon.css";
import "../assets/vendor/line-awesome/dist/line-awesome/css/line-awesome.min.css";
import "../assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import { useTranslate } from "../hooks/LanguageProvider";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ForgotPasswordCover: React.FC = () => {
  const { translate } = useTranslate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const submitBtnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "Enter" && submitBtnRef.current) submitBtnRef.current.click();
    };
    document.body.addEventListener("keypress", handleKeyPress);
    return () => document.body.removeEventListener("keypress", handleKeyPress);
  }, []);

  const handleSendResetLink = async () => {
    if (!email.trim()) {
      setAlertMessage(translate("Email") + " " + translate("is required"));
      return;
    }

    try {
      setLoading(true);
      setAlertMessage("");

      // ✅ adapte l'endpoint selon ton backend
      await axios.post(`${backendUrl}/api/forgot-password`, { email });

      // message succès
      setAlertMessage(translate("Reset link sent. Please check your email."));
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
        translate("connectionProblem") ||
        "Connection error."
      );
      console.error("Forgot password error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrapper">
      <section className="login-content">
        <div className="row">
          {/* ✅ côté image (même modèle que ton login) */}
          <div className="col-sm-7" style={{ margin: 0, padding: 0 }}>
            <div className="aida-bg-auth"></div>
          </div>

          {/* ✅ côté form */}
          <div className="col-sm-5" style={{ padding: "25px 30px" }}>
            <div className="card-body p-0">
              {/* logo */}
              <div className="row d-flex flex-column align-items-center justify-content-center">
                <div className="col-lg-12 text-center">
                  <img
                    src="asset/images/logo.png"
                    alt="AIADI"
                    className="img-fluid small-logo"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "200px",
                      marginTop: "40px",
                    }}
                  />
                </div>
              </div>

              {/* ✅ wrapper "cover" style Vuexy */}
              <div
                className="d-flex align-items-center auth-bg px-2 p-lg-5"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  height: "75vh",
                  paddingTop: "15vh",
                  transform: "translateY(-15%)",
                }}
              >
                <div className="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                  <h2 className="card-title  mb-1">
                    {translate("Forgot Password")}?
                  </h2>

                  <p className="card-text mb-2">
                    {translate(
                      "Enter your email and we'll send you instructions to reset your password"
                    )}
                  </p>

                  <form
                    className="auth-forgot-password-form mt-2"
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSendResetLink();
                    }}
                    noValidate
                  >
                    <div className="mb-1">
                      <label className="form-label" htmlFor="forgot-password-email">
                        {translate("Email")}
                      </label>

                      <input
                        className="form-control"
                        id="forgot-password-email"
                        type="text"
                        name="forgot-password-email"
                        placeholder="john@example.com"
                        aria-describedby="forgot-password-email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading}
                      />
                    </div>

                    <button
                      ref={submitBtnRef}
                      type="submit"
                      className="btn btn-primary w-100  mb-1 mt-4"
                      disabled={loading}
                    >
                      {translate("Send reset link")}
                    </button>

                    {loading && (
                      <div className="text-center mt-2">
                        <BeatLoader loading={loading} size={10} />
                      </div>
                    )}
                  </form>

                  {alertMessage && (
                    <div
                      style={{
                        padding: "12px",
                        marginTop: "12px",
                        border: "1px solid transparent",
                        borderRadius: "4px",
                        color: "#0f5132",
                        backgroundColor: "#d1e7dd",
                        borderColor: "#badbcc",
                        textAlign: "center",
                      }}
                      role="alert"
                    >
                      {alertMessage}
                    </div>
                  )}

                  <p className="text-center mt-2">
                    <Link to="/login" style={{ textDecoration: "none" }}>
                      <span style={{ marginRight: 6 }}>‹</span>
                      {translate("Back to login")}
                    </Link>
                  </p>
                </div>
              </div>
              {/* end cover */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgotPasswordCover;